import CustomerBanner from "../home/Customers";
import IntroCard from "./IntroCard";
import OverView from "./Overview";
import Journey from "./Journey";
import { motion } from "framer-motion";
import { Card, CardContent } from "@mui/material";

const AboutUs = () => {
  return (
    <motion.div
      initial={{ y: "100vh" }}
      animate={{ y: 0 }}
      transition={{ type: "tween", duration: 1 }}
      exit={{ y: "100vw" }}
    >
      <div className="flex flex-col w-full relative mt-24">
        <img
          className="absolute top-0 left-0 w-20 sm:w-24 md:w-40 "
          src="/images/about_vectLeft.svg"
          alt="Left Vector"
        />
        <img
          className="absolute top-0 right-0 w-24 sm:w-24 md:w-44 "
          src="/images/about_vectRight.svg"
          alt="Right Vector"
        />

        <div className="flex flex-col md:flex-row text-slate-200 font-HNlight text-center mx-auto mt-4 text-lg">
          About Us
        </div>
        <div className="flex flex-col md:flex-row text-3xl md:leading-[55px] md:text-5xl text-[#00A19B] mx-auto tracking-tighter">
          Bringing Your Vision to Life
          <br />
          with Expertise and Dedication
        </div>
        <IntroCard />
        <OverView />
        <Journey />
      </div>
      {/* Stats Bar */}
      <div className="text-3xl md:text-5xl text-[#00B4AE] m-8">
        Why choose us
      </div>
      <div className="flex flex-row mx-6 md:mx-52  bg-[#D9A900]  rounded-[20px] my-4">
        <Card
          sx={{
            boxShadow: 4,
            margin: 2,
            borderRadius: 3,
            backgroundColor: "#F9C200",
            width: "100%",
            padding: 0,
          }}
        >
          <CardContent
            sx={{ padding: 0, "&:last-child": { paddingBottom: 0 } }}
          >
            <div className="flex flex-row w-full justify-around text-[#423400] my-1">
              <div className="flex flex-col text-right">
                <div className="text-xl md:text-3xl font-HNbold">35+</div>
                <div className="text-sm md:text-base font-HNmed">Years</div>
              </div>
              <div className="flex flex-col text-right">
                <div className="text-xl md:text-3xl font-HNbold">60+</div>
                <div className="text-sm md:text-base font-HNmed">Products</div>
              </div>
              <div className="flex flex-col text-right">
                <div className="text-xl md:text-3xl font-HNbold">120+</div>
                <div className="text-sm md:text-base font-HNmed">Customers</div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="whyChooseUs flex flex-col bg-black px-[20%] pb-12">
        <div className="text-3xl md:text-5xl text-[#00B4AE] m-8">
          Crafting Excellence
        </div>
        <div className="text-slate-300 mb-5 md:text-lg">
          Driven by a relentless pursuit of quality, we meticulously engineer
          each product to surpass industry standards. Our dedication to
          excellence ensures that every bottle cap reflects the precision and
          sophistication synonymous with our brand.
        </div>

        <div className="text-3xl md:text-5xl text-[#00B4AE] m-8">
          Customer-Centric Approach
        </div>
        <div className="text-slate-300 mb-5 md:text-lg">
          Our customers are at the heart of everything we do. We prioritize your
          needs, collaborating closely to understand your vision and deliver
          tailored solutions that elevate your brand. Your satisfaction is our
          driving force, guiding us to continually innovate and exceed your
          expectations.
        </div>

        <div className="text-3xl md:text-5xl text-[#00B4AE] m-8">
          Join Us on Our Journey
        </div>
        <div className="text-slate-300 mb-5 md:text-lg">
          Join us as we continue to shape the future. At V Pack, excellence is
          not just a goal; it's our standard. Experience the difference with us
          and witness firsthand the unparalleled craftsmanship and dedication
          that define who we are.
        </div>
      </div>

      <CustomerBanner />
    </motion.div>
  );
};
export default AboutUs;
